exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */:host{position:relative;z-index:1;padding:0 10%;bottom:33px}.chart-axis{display:flex;flex-direction:row;justify-content:space-between}.chart-axis-label{color:#8b8b8b;font-size:10px;text-align:center;flex:1;line-height:14px;padding-right:5px}", ""]);

// exports
